import React from 'react';
import Init from './tests/init';

export default function App() {
  return (
    <div className="w-screen h-screen">
      <Init />
    </div>
  );
}
